module.exports = __webpack_public_path__ + "static/media/Third-FlagDistortLarge.77859a44.gif";